// pages/TestePagamento.tsx
export default function TestePagamento() {
  return (
    <iframe
      src="https://api.fightgo.com.br/mp-test.html"
      style={{ width: "100%", height: "100vh", border: "none" }}
    />
  );
}
